module.exports = __webpack_public_path__ + "static/media/3DPPA12.2d8d05e0.jpg";